<mat-drawer-container class="subpages-container extraction-page">
    <mat-drawer-content fxLayout="column">
      <div class="main-content">
        <div class="main-content">
          <div class="section-header">
            <div class="section-header-text">
              Upload GRLC Transaction File
            </div>
          </div>
          <div class="multi-step-form" style="height: 670px !important; overflow-y: auto !important">
            <mat-horizontal-stepper linear #stepper>
              <mat-step [stepControl]="firstFormGroup">
                <form [formGroup]="firstFormGroup">
                  <ng-template matStepLabel>Details</ng-template>
                  <div class="multi-step-form-inner">
                    <div class="multi-step-form-item form-group">
                      <h4 class="multi-step-field-label">Form</h4>

                      <mat-form-field class="multi_step_field" floatLabel="never" appearance="outline">
                        <input id="autoCompleteInput" type="text" [formControl]="myControl" [(ngModel)]="formNumberVal" formControlName="formNumber" class="form-control"
                          (input)="checkForm()" placeholder="form" matInput [matAutocomplete]="auto"/>
                        <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectForm($event)">
                          <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
                            {{ option.number.replace('_',' ') }}
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>

                      <div *ngIf="submitted && formNoRequired" class="invalid-feedback">
                        <div class="has-error">Form is required</div>
                      </div>
                      <!-- <div *ngIf="!formAvailable" class="invalid-feedback">
                        <div class="has-error">Form not available.</div>
                      </div> -->
                    </div>
                    <div class="multi-step-form-item">
                      <h4 class="multi-step-field-label">Upload File (Only PDF & Excel)</h4>
                      <div class="upload-btn-wrapper red-border" [ngClass]="{'red-border': (submitted && noFileSelected) || fileExtnError}">
                        <div class="file-name">{{ fileName }}</div>
                        <button class="btn-browse">Browse</button>
                        <input type="file" name="myfile" [(ngModel)]="fileUpload" formControlName="fileToUpload" accept="application/pdf, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" ng2FileSelect (change)='openFile($event)' required />
                        <!-- <input type="file" name="myfile" [(ngModel)]="fileUpload" formControlName="fileToUpload" accept="application/pdf" ng2FileSelect (change)='openFile($event)' required /> -->
                      </div>
                      <div *ngIf="submitted && noFileSelected" class="invalid-feedback">
                          <div class="has-error">No file selected</div>
                        </div>
                        <div *ngIf="fileExtnError" class="invalid-feedback">
                          <div class="has-error">Invalid file format</div>
                        </div>
                    </div>

                    <div class="multi-step-form-item">
                      <h4 class="multi-step-field-label"></h4>
                      <div>
                        <mat-checkbox formControlName="addressSplit">Address Split</mat-checkbox>
                      </div>
                    </div>

                    <div class="multi-step-form-item form-group">
                      <h4 class="multi-step-field-label">Sender Code</h4>
                      <mat-form-field class="multi_step_field" floatLabel="never" appearance="outline">
                         <input type="text" formControlName="senderCode" class="form-control"
                           placeholder="sender code" matInput [(ngModel)]="senderCode"/>
                      </mat-form-field>

                      <h4 class="multi-step-field-label">Receiver Code</h4>
                      <mat-form-field class="multi_step_field" floatLabel="never" appearance="outline">
                         <input type="text" formControlName="receiverCode" class="form-control"
                           placeholder="receiver code" matInput [(ngModel)]="receiverCode"/>
                      </mat-form-field>
                    </div>

                    <div class="multi-step-form-item">
                      <button mat-button class="mat-button multi-step-btn btn-primary" [disabled]="fileExtnError"
                        (click)="MoveNext(stepper)" style="margin-right: 10px;">Next</button>
                      <button mat-button class="mat-button multi-step-btn btn-primary" (click)="resetForm()">Reset form</button>
                    </div>
                  </div>
                </form>
                <ngx-spinner></ngx-spinner>
                <div class="tooltip-close" *ngIf="closeRequest">
                    <i matTooltip="Close" class="material-icons" (click)="closeLoading()">clear</i>
                </div>
              </mat-step>
              <mat-step #secondstep>
                <ng-template matStepLabel>Download</ng-template>
                <ng-container *ngIf="stepper.selected == secondstep">
                  <form class="details-form">
                    <div class="multi-step-form-item outputPDF">
                      <h4 class="multi-step-field-label">Input FileName: {{ fileName }} </h4>
                      <div class="textarea-container">
                        <div class="download-textarea">
                          <div id="pdf-form-container" class="zoomIt">
                            <app-extexcelviewer *ngIf="pdfData && docType=='excel'" [excelFile]="pdfData"></app-extexcelviewer>

                            <pdf-viewer *ngIf="pdfSrc && docType=='pdf'" [src]="pdfSrc" [page]="page" [render-text]="true"
                              style="display: block;"></pdf-viewer>

                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="multi-step-form-item outputXML margin-free">
                      <h4 class="multi-step-field-label">Output File</h4>
                      <h5 style="color:red" *ngIf="showDownloadMsg">Please use download button for the whole file</h5>
                      <div class="textarea-container" *ngIf="!pdfError">
                        <div class="download-textarea">
                          <p>{{ xmlData }}</p>
                        </div>
                      </div>
                      <div class="textarea-container" *ngIf="pdfError">
                        <div class="download-textarea">
                          <p>{{ errorMessage }}</p>
                        </div>
                      </div>
                    </div>
                  </form>
                </ng-container>
                <div class="submit-form-btn">
                      <button mat-button matStepperPrevious class="multi-step-btn margin-rt-2">Back</button>
                      <button mat-button (click)="Download()" class="multi-step-btn">Download</button>
                </div>
              </mat-step>
            </mat-horizontal-stepper>
          </div>
        </div>
      </div>
    </mat-drawer-content>
  </mat-drawer-container>
